<template>
  <div class="home">
    <img
      v-if="$i18n.locale === 'ja'"
      src="@/assets/images/0_img_bannerjp.png"
      alt=""
      class="placeholder-banner"
    />
    <img
      v-else
      src="@/assets/images/0_img_banner.png"
      alt=""
      class="placeholder-banner"
    />
    <div class="container">
      <div class="title">{{ $t('home.coreBusiness') }}</div>
      <div class="line-container">
        <div class="line short-line"></div>
        <div class="line middle-line"></div>
        <div class="line short-line" style="transform: scaleX(-1)"></div>
      </div>
      <div class="core-business flex mt100">
        <img src="@/assets/images/0_img_1.png" alt="" />
        <div class="right">
          <div class="title flex">
            <div class="triangle"></div>
            <span>{{ $t('home.platform') }}</span>
          </div>
          <div class="text">{{ $t('home.formulation') }}</div>
          <div class="list flex">
            <section>
              <div class="sec-title">{{ $t('home.dosageForm') }}</div>
              <div class="sec-text">
                {{ $t('home.dosageForms.oralFilms') }} <br />
                {{ $t('home.dosageForms.transdermal') }} <br />
                {{ $t('home.dosageForms.granule') }}
              </div>
            </section>
            <section>
              <div class="sec-title">{{ $t('home.application') }}</div>
              <div class="sec-text">
                {{ $t('home.applicationText') }}
              </div>
            </section>
          </div>
        </div>
      </div>
      <div class="title flex title-2">
        <div class="triangle"></div>
        <span>{{ $t('home.platform') }}</span>
      </div>
      <div class="flex step-list">
        <div class="li special-effects">
          <img src="@/assets/images/0_img_2.png" alt="" />
          <div class="step-text">{{ $t('home.productStrategy') }}</div>
        </div>
        <div class="li special-effects">
          <img src="@/assets/images/0_img_3.png" alt="" />
          <div class="step-text">
            {{ $t('home.productInfo') }}
          </div>
        </div>
        <div class="li special-effects">
          <img src="@/assets/images/0_img_4.png" alt="" />
          <div class="step-text">{{ $t('home.productRegistration') }}</div>
        </div>
      </div>
      <div class="flex step-list step-list-bot">
        <div class="li special-effects">
          <img src="@/assets/images/0_img_5.png" alt="" />
          <div class="step-text">{{ $t('home.salesMarket') }}</div>
        </div>
        <div class="li li-5 special-effects">
          <img src="@/assets/images/0_img_6.png" alt="" />
          <div class="step-text">
            {{ $t('home.supplyDistribution') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
};
</script>
<style lang="less" scoped>
.title {
  align-items: center;
  .triangle {
    width: 0;
    height: 0;
    border-top: 25px solid transparent;
    border-bottom: 25px solid transparent;
    border-left: 50px solid orange;
  }
  span {
    font-size: 30px;
    font-weight: bolder;
    margin-left: 20px;
  }
}
.core-business {
  .right {
    margin-left: 25px;
    .text {
      margin-top: 20px;
      font-size: 49px;
      color: #999;
      font-weight: 100;
    }
    .list {
      justify-content: space-between;
      margin-top: 20px;
      section {
        width: 306px;
        height: 219px;
        background: #f9f9f9;
        padding: 38px 20px;
        box-sizing: border-box;
      }
      .sec-title {
        font-size: 24px;
        font-weight: bolder;
        color: #654495;
      }
      .sec-text {
        line-height: 35px;
        font-size: 18px;
        margin-top: 11px;
      }
    }
  }
}
.title-2 {
  margin-top: 60px;
}
.step-list {
  margin-top: 50px;
  flex-wrap: wrap;
  justify-content: space-between;
  .li {
    width: 400px;
    height: 322px;
    background: #f9f9f9;
  }
  .step-text {
    height: 70px;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    white-space: pre-line;
  }
}
.step-list-bot{
  justify-content: center;
  .li-5{
    margin-left: 50px;
  }
}
</style>
